import React from 'react';
import c from '../w.js';

const IconArrowOut = React.memo(
  c(
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11 15.9999V7.41412L7.70711 10.707L6.29289 9.2928L11.2929 4.2928L12 3.58569L12.7071 4.2928L17.7071 9.2928L16.2929 10.707L13 7.41412V15.9999H11ZM6 15.9999V17.9999H18V15.9999H20V18.9999V19.9999H19H5H4V18.9999V15.9999H6Z"
      }
    )
  )
);

export { IconArrowOut };
